import {
  Box,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { sizes } from "./analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./analyzeSlice";

export default function Header() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const { analysisTypes, selectedAnalysisType } = state;

	const loginState = useSelector((store) => store.login);
	const { isGCountryChangedAnalyze,} = loginState 

  const [aTypes, setATypes] = useState(analysisTypes);

  useEffect(() => {
    if(!isGCountryChangedAnalyze)
    dispatch(setState("selectedAnalysisType", ""));
  },[])

  useEffect(() => {
    // let aTypes = analysisTypes;
    // aTypes.push({analysisID: 7, analysisName: 'Trade Details', analyzeTradeDetails: null},
    // {analysisID: 9, analysisName: 'Invented vs Delevered', analyzeTradeDetails: null});

    setATypes(analysisTypes);
  }, [analysisTypes]);

  function selectAnalysisType(event) {
    const type = event.target.value;
    console.log("type", type);
    // const typeID = analysisTypes.find(
    // 	(analysisType) => analysisType.analysisName === type
    // ).analysisID;
    const typeID = aTypes.find(
      (analysisType) => analysisType.analysisName === type
    ).analysisID;
    dispatch(setState("selectedAnalysisType", type));
    dispatch(setState("selectedAnalysisTypeID", typeID));
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="subtitle1" sx={{ mt: 3, mr: 4 }}>
          Analyze
        </Typography>
        <FormControl sx={{ mt: 2, mr: 4 }}>
          <InputLabel>Select Analysis Type</InputLabel>
          <Select
            value={selectedAnalysisType}
            label="Select Analysis Type"
            sx={{
              height: sizes.h35,
              color: "black.main",
              mt: 1,
              maxWidth: "300px",
            }}
            onChange={selectAnalysisType}
          >
            {aTypes?.map((analysisType, index) => {
              return (
                <MenuItem key={index} value={analysisType.analysisName}>
                  {analysisType.analysisName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>

      <Divider sx={{ mt: 3 }} />
    </Box>
  );
}
